module.exports = "<router-outlet></router-outlet>\n<ngx-loading [show]=\"ENV.loading\" [config]=\"{'fullScreenBackdrop': true}\"></ngx-loading>"